import {colorGrades, fillColors} from "./config";

export const getColor = (value: number, max: number) => {
    let length =fillColors.length - 1;
    const index = length - [...colorGrades].reverse().findIndex((grade)=> (value > (max *  grade)));
    return fillColors[index];
}

export const sortMapData = (a: any, b: any) => {
    if (a[1] < b[1]) return -1;
    if (a[1] > b[1]) return 1;
    return 0;
};
